import React from "react";
import { Link } from "react-router-dom";
import { useMarketplace } from "../../context/MarketplaceContext";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { currentMarketplace } = useMarketplace();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="site-footer py-8 px-4 md:px-6 text-white">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {/* Brand and Description */}
          <div className="col-span-1">
            <div className="flex items-center mb-4">
              <span className="text-xl font-bold text-white">
                {currentMarketplace.name}
              </span>
            </div>
            <p className="text-gray-300 mb-4 md:mb-0">
              Your trusted marketplace for high-quality products and services.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-white font-bold mb-4 text-lg">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection("services")}
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Services
                </button>
              </li>
              <li>
                <Link
                  to="/trainings/full-stack"
                  className="text-gray-300 hover:text-white transition-colors duration-200 inline-block"
                >
                  Full Stack Developer Program
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("industry-resources")}
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Resources
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("marketplace")}
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Marketplace
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("requirement-form")}
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Requirement Form
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-1">
            <h3 className="text-white font-bold mb-4 text-lg">Contact Us</h3>
            <address className="text-gray-300 not-italic">
              <p>Pune, Maharashtra, India</p>
              <p className="mt-2">Email: miraz@devstackmarketplace.com</p>
            </address>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-300 text-sm md:text-base">
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <p>
              &copy; {currentYear} {currentMarketplace.name}. All rights
              reserved.
            </p>
            <div className="mt-4 sm:mt-0 space-x-4">
              <Link
                to="/terms"
                className="text-gray-300 hover:text-white transition-colors duration-200"
              >
                Terms
              </Link>
              <Link
                to="/privacy"
                className="text-gray-300 hover:text-white transition-colors duration-200"
              >
                Privacy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
